import { createSelector } from 'reselect'

export const getMealDetail = createSelector(
  state => state.mealDetail.data,
  meal => {
    if (!meal) {
      return null
    }

    return {
      imageFullUrl: meal.image.fullPath,
      chef_img: meal.chefLogo,
      stars: 0,
      chef_firstname: meal.chefFirstname,
      chef_lastname: meal.chefLastname,
      specificationsDetails: meal.specificationsDetail,
      meal_story: meal.mealStory,
      ...meal
    }
  }
)

export const mealDetailLoading = createSelector(
  state => state.mealDetail.loading,
  loading => loading
)



// WEBPACK FOOTER //
// ./src/selectors/mealDetail.js